import { Link } from "@tanstack/react-router"
import { LockIcon } from "lucide-react"

import { Button } from "@/components/ui/button"
import { Card, CardTitle } from "@/components/ui/card"
import ApplicationsImage from "@/svg/home/applications.svg?react"
type ApplicationsCardProps = {
  disabled: boolean
}

export default function ApplicationsCard({ disabled }: ApplicationsCardProps) {
  return (
    <Card className="relative min-w-0 overflow-hidden p-6">
      <div className="relative z-10 flex h-full min-w-0 flex-col justify-between md:pr-[min(10rem,45%)]">
        <div>
          <div className="mb-6">
            <CardTitle>Your Applications</CardTitle>
          </div>
          <p className="mb-4">
            View and manage your submitted funding applications.
          </p>
        </div>
        {disabled ? (
          <Button disabled className="bg-primary self-start">
            View Applications
            <LockIcon className="ml-2 h-4 w-4" />
          </Button>
        ) : (
          <Button className="bg-primary self-start" asChild>
            <Link to="/applications">View Applications</Link>
          </Button>
        )}
      </div>

      <ApplicationsImage className="pointer-events-none absolute right-0 hidden h-auto w-full md:bottom-0 md:block md:w-48 xl:w-48" />
    </Card>
  )
}
